import type { ReactNode } from "react";

type Props = {
  title: string;
  text: string;
  action?: ReactNode;
};

export function CabinetEmptyState({ title, text, action }: Props) {
  return (
    <div className="wb-cabinet-empty">
      <p className="wb-cabinet-empty__title">{title}</p>
      <p className="wb-cabinet-empty__text">{text}</p>
      {action ? <div className="wb-cabinet-empty__action">{action}</div> : null}
    </div>
  );
}
